// #7322 increment 2 HOLD fix (size law) — split out of gate-ledger.ts to bring
// that touched file back under 674 lines after this PR's own additive reason
// code. Pure vocabulary, content-identical move: no logic change, re-exported
// from gate-ledger.ts so its own public API (and `@helix/lib`'s) is unchanged.

export const GATE_LEDGER_EGRESS_REASON_CODES = Object.freeze([
  'stream_numeric_redaction',
  'stream_rif_execution_directive',
] as const);

export type GateLedgerEgressReasonCode =
  (typeof GATE_LEDGER_EGRESS_REASON_CODES)[number];
